import { render } from "./CDatePicker.vue?vue&type=template&id=08fa4a5e"
import script from "./CDatePicker.vue?vue&type=script&lang=js"
export * from "./CDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__